let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1imaz")).then(() => parcelRequire('90tnF'));